import { render, staticRenderFns } from "./DetailsPlanOrFee.vue?vue&type=template&id=0cb0f5b6"
import script from "./DetailsPlanOrFee.vue?vue&type=script&lang=js"
export * from "./DetailsPlanOrFee.vue?vue&type=script&lang=js"
import style0 from "./DetailsPlanOrFee.vue?vue&type=style&index=0&id=0cb0f5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports